import React from 'react';
import { motion } from 'framer-motion';

const TechStackSwiper = () => {
  // Tech stack data with icons
  const techStack = [
    { name: 'React', color: 'text-blue-500', bgColor: 'bg-blue-100 dark:bg-blue-900/30' },
    { name: 'JavaScript', color: 'text-yellow-500', bgColor: 'bg-yellow-100 dark:bg-yellow-900/30' },
    { name: 'PHP', color: 'text-purple-500', bgColor: 'bg-purple-100 dark:bg-purple-900/30' },
    { name: 'HTML5', color: 'text-orange-500', bgColor: 'bg-orange-100 dark:bg-orange-900/30' },
    { name: 'CSS3', color: 'text-blue-600', bgColor: 'bg-blue-100 dark:bg-blue-900/30' },
    { name: 'Tailwind', color: 'text-cyan-500', bgColor: 'bg-cyan-100 dark:bg-cyan-900/30' },
    { name: 'State Management', color: 'text-indigo-500', bgColor: 'bg-indigo-100 dark:bg-indigo-900/30' },
    { name: 'Backend Technologies', color: 'text-green-600', bgColor: 'bg-green-100 dark:bg-green-900/30' },
    { name: 'UI/UX', color: 'text-pink-500', bgColor: 'bg-pink-100 dark:bg-pink-900/30' },
    { name: 'API Integration', color: 'text-teal-500', bgColor: 'bg-teal-100 dark:bg-teal-900/30' },
    { name: 'DBMS', color: 'text-red-500', bgColor: 'bg-red-100 dark:bg-red-900/30' },
    { name: 'Cloud', color: 'text-sky-500', bgColor: 'bg-sky-100 dark:bg-sky-900/30' },
    { name: 'CMS', color: 'text-violet-500', bgColor: 'bg-violet-100 dark:bg-violet-900/30' },
    { name: 'Tools & Build Systems', color: 'text-amber-600', bgColor: 'bg-amber-100 dark:bg-amber-900/30' },
    { name: 'Performance & Security', color: 'text-rose-600', bgColor: 'bg-rose-100 dark:bg-rose-900/30' },
    { name: 'System Design', color: 'text-emerald-600', bgColor: 'bg-emerald-100 dark:bg-emerald-900/30' }
  ];

  const itemVariants = {
    hidden: { y: 30, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.6,
        ease: [0.25, 0.46, 0.45, 0.94]
      }
    }
  };

  return (
    <motion.div
      variants={itemVariants}
      className="space-y-6 overflow-hidden"
    >
      <div className="text-center">
        <h3 className="text-lg font-semibold text-gray-700 dark:text-gray-300 mb-6">
          Technologies I Work With
        </h3>
      </div>

      <div className="relative">
        <div className="tech-scroll-container">
          <div className="tech-scroll-content">
            {/* First set of items */}
            {techStack.map((tech, index) => (
              <div
                key={`tech-1-${index}`}
                className={`tech-item flex items-center gap-3 px-6 py-3 ${tech.bgColor} rounded-full border border-gray-200 dark:border-gray-700 hover:shadow-lg transition-all duration-300 cursor-default whitespace-nowrap`}
              >
                <div className={`w-2 h-2 ${tech.color} bg-current rounded-full`}></div>
                <span className={`font-medium ${tech.color}`}>
                  {tech.name}
                </span>
              </div>
            ))}
            {/* Duplicate set for seamless loop */}
            {techStack.map((tech, index) => (
              <div
                key={`tech-2-${index}`}
                className={`tech-item flex items-center gap-3 px-6 py-3 ${tech.bgColor} rounded-full border border-gray-200 dark:border-gray-700 hover:shadow-lg transition-all duration-300 cursor-default whitespace-nowrap`}
              >
                <div className={`w-2 h-2 ${tech.color} bg-current rounded-full`}></div>
                <span className={`font-medium ${tech.color}`}>
                  {tech.name}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Custom animations */}
      <style jsx>{`
        @keyframes scroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }

        .tech-scroll-container {
          overflow: hidden;
          position: relative;
          width: 100%;
          mask-image: linear-gradient(
            to right,
            transparent 0%,
            black 10%,
            black 90%,
            transparent 100%
          );
          -webkit-mask-image: linear-gradient(
            to right,
            transparent 0%,
            black 10%,
            black 90%,
            transparent 100%
          );
        }

        .tech-scroll-content {
          display: flex;
          gap: 1rem;
          animation: scroll 40s linear infinite;
          width: fit-content;
        }

        .tech-scroll-content:hover {
          animation-play-state: paused;
        }

        .tech-item {
          flex-shrink: 0;
        }

        @media (max-width: 640px) {
          .tech-scroll-content {
            animation: scroll 30s linear infinite;
            gap: 0.75rem;
          }
        }

        @media (max-width: 768px) {
          .tech-scroll-content {
            animation: scroll 35s linear infinite;
          }
        }
      `}</style>
    </motion.div>
  );
};

export default TechStackSwiper;
